$(function() {
  if ($("[data-tabs]").length) {
    var tabs = new Tabby("[data-tabs]");
  }
  if ($('.setu-testimonials').length) {
    const numSlides = parseInt($('.setu-testimonials').attr("data-number-slides"));
    const lastSlideIndex = numSlides - 1;
    const mainSlider = new Swiper('#testi-main-slider', {
      slidesPerView: 1,
      loop: true,
      initialSlide: 0,
      effect: "creative",
      grabCursor: true,
      longSwipes: false,
      shortSwipes: true,
      followFinger: false,
      creativeEffect: {
        prev: {
          shadow: false,
          translate: ["-100%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      }
    });
    const prevSlider = new Swiper("#testi-prev-slider", {
      initialSlide: lastSlideIndex,
      slidesPerView: 1,
      loop: true,
      allowTouchMove: false,
      effect: "creative",
      creativeEffect: {
        prev: {
          shadow: false,
          translate: ["-100%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      }
    });
    const nextSlider = new Swiper("#testi-next-slider", {
      initialSlide: 1,
      slidesPerView: 1,
      loop: true,
      allowTouchMove: false,
      effect: "creative",
      creativeEffect: {
        prev: {
          shadow: false,
          translate: ["-100%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      }
    });

    var activeSlider = "slider1";
    mainSlider.on("sliderMove", function() {
      activeSlider = "slider1";
    });

    prevSlider.on("sliderMove", function() {
      activeSlider = "slider2";
    });

    nextSlider.on("sliderMove", function() {
      activeSlider = "slider3";
    });

    mainSlider.on("slideChangeTransitionStart", function(swiper) {
      mainSlider.disable();
      if (activeSlider == "slider1") {
        if (swiper.swipeDirection == "next") {
          prevSlider.slideNext();
          nextSlider.slideNext();
        } else {
          prevSlider.slidePrev();
          nextSlider.slidePrev();
        }
      }
    });

    prevSlider.on("slideChangeTransitionStart", function(swiper) {
      prevSlider.disable();
      if (activeSlider == "slider2") {
        if (swiper.swipeDirection == "next") {
          mainSlider.slideNext();
          nextSlider.slideNext();
        } else {
          mainSlider.slidePrev();
          nextSlider.slidePrev();
        }
      }
    });

    prevSlider.on("click", function(swiper) {
      activeSlider = "slidernone";
      mainSlider.slidePrev();
      prevSlider.slidePrev();
      prevSlider.disable();
      nextSlider.slidePrev();
      prevSlider.enable();
    });

    nextSlider.on("slideChangeTransitionStart", function(swiper) {
      nextSlider.disable();
      if (activeSlider == "slider3") {
        if (swiper.swipeDirection == "next") {
          mainSlider.slideNext();
          prevSlider.slideNext();
        } else {
          mainSlider.slidePrev();
          prevSlider.slidePrev();
        }
      }
    });

    nextSlider.on("click", function(swiper) {
      activeSlider = "slidernone";
      nextSlider.slideNext();
      nextSlider.disable();
      prevSlider.slideNext();
      mainSlider.slideNext();
      nextSlider.enable();
    });

    mainSlider.on("slideChangeTransitionEnd", function(swiper) {
      mainSlider.enable();
    });

    prevSlider.on("slideChangeTransitionEnd", function(swiper) {
      prevSlider.enable();
    });

    nextSlider.on("slideChangeTransitionEnd", function(swiper) {
      nextSlider.enable();
    });
  }

  function prevAll(element) {
    var result = [];

    while ((element = element.previousElementSibling)) result.push(element);
    return result;
  }

  function nextAll(element) {
    var result = [];

    while ((element = element.nextElementSibling)) result.push(element);
    return result;
  }

  const cards = document.querySelectorAll(".setu-card");
  const cardsParent = document.querySelector(".setu-cards");
  let activeCard = cards[0];

  cards.forEach((card) => {
    card.addEventListener("click", () => {
      activeCard.classList.remove("setu-card--active", "setu-card--next", "setu-card--prev");
      activeCard = card;
      var prevCards = prevAll(activeCard);
      var nextCards = nextAll(activeCard);
      cardsParent.setAttribute("data-prev-length", prevCards.length);
      cardsParent.setAttribute("data-next-length", nextCards.length);
      prevCards.forEach(function(item) {
        item.classList.remove("setu-card--next");
        item.classList.add("setu-card--prev");
      });
      nextCards.forEach(function(item) {
        item.classList.remove("setu-card--prev");
        item.classList.add("setu-card--next");
      });
      activeCard.classList.remove("setu-card--prev", "\setu-card--next");
      activeCard.classList.add("setu-card--active");
    });
  });

  $('.product-card--carousel').each(function(index, el) {
    var sliderID = "#" + $(el).attr("id");
    var prevClass = "." + $(this).parent().find(".swiper-button-prev").attr("class").replace(" swiper-button-prev", "");
    var nextClass = "." + $(this).parent().find(".swiper-button-next").attr("class").replace(" swiper-button-next", "");
    new Swiper(sliderID, {
      slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 20,
      // loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: nextClass,
        prevEl: prevClass,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.6,
          spaceBetween: 10
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 1.5,
          spaceBetween: 20
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        // when window width is >= 768px
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    });
  });

  $('.product-card--newleanlitecarousel').each(function(index, el) {
    var sliderID = "#" + $(el).attr("id");
    var prevClass = "." + $(this).parent().find(".swiper-button-prev").attr("class").replace(" swiper-button-prev", "");
    var nextClass = "." + $(this).parent().find(".swiper-button-next").attr("class").replace(" swiper-button-next", "");
    new Swiper(sliderID, {
      slidesPerView: 4,
      slidesPerGroup: 1, arrows: false,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: nextClass,
        prevEl: prevClass,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2.4,
          spaceBetween: 10
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        // when window width is >= 768px
        768: {
          slidesPerView: 3.4,
          spaceBetween: 20
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    });
  });

  const swiper = new Swiper('.swiper-health-goals', {
    // Default parameters
    slidesPerView: 6,
    spaceBetween: 10,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 3.5,
        spaceBetween: 20
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 5,
        spaceBetween: 30
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 7,
        spaceBetween: 40
      }
    }
  })


  const recently = new Swiper('.recently-product--carousel', {
    // Default parameters
    slidesPerView: 4,
    spaceBetween: 10,
    navigation: {
      nextEl: '.recently-swiper-next',
      prevEl: '.recently-swiper-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 4,
        spaceBetween: 30
      }
    }
  })

  const SetuTabs = new Swiper('.SetuTabs-swiper', {
    // Default parameters
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.3,
        spaceBetween: 20
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1.5,
        spaceBetween: 30
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 1.7,
        spaceBetween: 40
      }
    }
  })

  var Testimonials = new Swiper('.testimonials02', {
    slidesPerView: 2,
    centeredSlides: true,
    loop: true,
    speed: 500,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // Responsive breakpoints
    breakpoints: {
      768: {
        slidesPerView: 1.2,
        spaceBetween: 0
      },
      1024: {
        slidesPerView: 1.5,
        spaceBetween: 0
      },
      1300: {
        slidesPerView: 2,
        spaceBetween: 0
      }
    }
  });

  var Testimonials = new Swiper('.testimonials03', {
    slidesPerView: 2,
    centeredSlides: true,
    loop: true,
    speed: 500,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // Responsive breakpoints
    breakpoints: {
      768: {
        slidesPerView: 1.2,
        spaceBetween: 0
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 0
      },
      1300: {
        slidesPerView: 2,
        spaceBetween: 0
      }
    }
  });

  // var articles = new Swiper('.article__card_slide', {
  //   slidesPerView:3,
  //   loop: true,
  //   speed: 500,
  //   spaceBetween: 30,
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },
  //   // Responsive breakpoints
  //   breakpoints: {
  //     768: {
  //       slidesPerView: 3,
  //       spaceBetween: 30
  //     }
  //   }
  // });
  $('.article__card_slide').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    rows: 0,
    dots: true,
    arrows: true,
    prevArrow: "<svg class='img-responsive slick-prev' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M7.5 14L1 7.5L7.5 1' stroke='black' stroke-linecap='round'/> </svg>",
    nextArrow: "<svg class='img-responsive slick-arrow slick-next' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M0.5 14L7 7.5L0.5 1' stroke='black' stroke-linecap='round'/> </svg>",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          slidesToShow: 1,
          // rows:2,
          centerMode: false,
        }
      },

    ]
  });

  const newswiper = new Swiper('.swiper-setu-testimonials', {
    // Default parameters
    slidesPerView: 1.5, centeredSlides: true, loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.3,
        spaceBetween: 10
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1.3,
        spaceBetween: 10
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 4,
        spaceBetween: 40
      }
    }
  });


  const cardsswiper = new Swiper('.setu-cards-swiper', {
    // Default parameters
    slidesPerView: 1,
    spaceBetween: 0, loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 40
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
        spaceBetween: 40
      }
    }
  })


  const Slideshow = new Swiper('.main-swiper', {
    // Default parameters
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }

  })

  // const Slideshow = new Swiper('.main-swiper', {
  //   // Default parameters
  //   slidesPerView: 1,
  //   spaceBetween: 0,
  //   loop: false,
  //   pagination: {
  //     el: '.swiper-pagination',
  //     type: 'bullets',
  //   }
  // })

  var MiniQuiz = new Swiper(".miniquizSwiper", {
    slidesPerView: 3,
    grid: {
      rows: 2,
    },
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });


  const BlogSlideshow = new Swiper('.blog-swiper', {
    // Default parameters
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      type: "fraction"
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 5000,
    },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 480px
      480: {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      }
    }

  })

  document.addEventListener("variantChange", function(variant) {
    //console.log(document);
  });


  const scrollContainer = document.querySelector('#setu-timeline');
  //console.log(scrollContainer.length);
  //if(scrollContainer != null && scrollContainer.length > 0) {
  if (scrollContainer != null || scrollContainer.length > 0) {
    scrollContainer.addEventListener("wheel", (evt) => {
      evt.preventDefault();
      scrollContainer.scrollLeft += evt.deltaY;
    });
  }
});

$(window).on('load', function() {
  var winW = $(window).outerWidth();
  //console.log(winW);
  if (winW < 767) {
    const highlights = new Swiper('.swiper-highlights', {
      // Default parameters
      slidesPerView: 3,
      spaceBetween: 10,

      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.4,
          spaceBetween: 10
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 3,
          spaceBetween: 30
        }
      }
    })

  }
});

$(".section-form__item").on("click", ".bze-option", function(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  var target = $(this).data("target");
  var mappedValue = $(this).data("mapped");
  var selectedFormID = $(this).closest('.buttonize').data("formid");
  $("#" + target)
    .val($(this).data("value"))
    .trigger("change");
  //console.log(this);
  //document.getElementById(target).dispatchEvent(new Event("change"));
  //$("#" + selectedFormID).find('#prop-packs').val(mappedValue);
  $('.bze-option[data-target="' + target + '"]').removeClass("is-active");
  $(this).addClass("is-active");
  $(this).parent(".prod-card-custom-drop-value").parent(".custom-select").find(".prod-card-custom-selected-data").text($(this).text());
});

$(document).ready(function() {
  if (typeof $.fn.Slick != 'undefined') {
    if (window.screen.width >= 768) {
      $('.quiz_slider').slick({
        infinite: true,
        dots: true,
        /*customPaging : function(slider, i) {
        var thumb = $(slider.$slides[i]).data();
        return '<a>'+(i+1)+'</a>';
        },*/
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<svg class='img-responsive slick-prev' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M7.5 14L1 7.5L7.5 1' stroke='black' stroke-linecap='round'/> </svg>",
        nextArrow: "<svg class='img-responsive slick-arrow slick-next' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M0.5 14L7 7.5L0.5 1' stroke='black' stroke-linecap='round'/> </svg>",
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              dots: false
            }
          },

        ]
      });
    }
    if (window.screen.width < 768) {
      $('.quiz_wrap').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
      });
    }

    $(".quiz_wrap").slice(0, 1).show();
    $(".tab_item").click(function() {
      $('.quiz_wrap').slick('refresh');
      var getId = $(this).attr("data-id");
      $(".tab_item").removeClass("active");
      $(this).addClass("active");
      $(".quiz_wrap").hide();
      $(getId).show();
    });
  }
});

$('.about-experts-cards').slick({
  infinite: true,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: false,
  prevArrow: "<svg class='img-responsive slick-prev' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M7.5 14L1 7.5L7.5 1' stroke='black' stroke-linecap='round'/> </svg>",
  nextArrow: "<svg class='img-responsive slick-arrow slick-next' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M0.5 14L7 7.5L0.5 1' stroke='black' stroke-linecap='round'/> </svg>",
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 2000,
      settings: "unslick"
    },
    {
      breakpoint: 1600,
      settings: "unslick"
    },
    {
      breakpoint: 1024,
      settings: "unslick"
    },
    {
      breakpoint: 767,
      settings: {
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<svg class='img-responsive slick-prev' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M7.5 14L1 7.5L7.5 1' stroke='black' stroke-linecap='round'/> </svg>",
        nextArrow: "<svg class='img-responsive slick-arrow slick-next' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M0.5 14L7 7.5L0.5 1' stroke='black' stroke-linecap='round'/> </svg>",
      }
    },

  ]
});
$('.content').slick({
  infinite: true,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: false,
  prevArrow: "<svg class='img-responsive slick-prev' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M7.5 14L1 7.5L7.5 1' stroke='black' stroke-linecap='round'/> </svg>",
  nextArrow: "<svg class='img-responsive slick-arrow slick-next' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M0.5 14L7 7.5L0.5 1' stroke='black' stroke-linecap='round'/> </svg>",
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 2000,
      settings: "unslick"
    },
    {
      breakpoint: 1600,
      settings: "unslick"
    },
    {
      breakpoint: 1024,
      settings: "unslick"
    },
    {
      breakpoint: 767,
      settings: {
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<svg class='img-responsive slick-prev' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M7.5 14L1 7.5L7.5 1' stroke='black' stroke-linecap='round'/> </svg>",
        nextArrow: "<svg class='img-responsive slick-arrow slick-next' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M0.5 14L7 7.5L0.5 1' stroke='black' stroke-linecap='round'/> </svg>",
      }
    },

  ]
});



$(".product-card--carousel").on("click", ".bze-option", function(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  var target = $(this).data("target");
  var mappedValue = $(this).data("mapped");
  var selectedFormID = $(this).closest('.buttonize').data("formid");
  $("#" + target)
    .val($(this).data("value"))
    .trigger("change");
  //console.log(this);
  document.getElementById(target).dispatchEvent(new Event("change"));
  $("#" + selectedFormID).find('#prop-packs').val(mappedValue);
  $('.bze-option[data-target="' + target + '"]').removeClass("is-active");
  $(this).addClass("is-active");
  $(this).parent(".prod-card-custom-drop-value").parent(".custom-select").find(".prod-card-custom-selected-data").text($(this).text());
});
//console.log("ready");
$('.prod-card-product-variation-drp').click(function() {
  //console.log("asd");
  $(".prod-card-custom-drop-value").hide();
  $(this).parent(".custom-select").find(".prod-card-custom-drop-value").show();
});
$(".prod-card-custom-drop-value").click(function() {
  $(this).hide();

});


$('.product-form__item--submit').click(function() {
  //console.log("asd");
});


$('.title').click(function() {
  //console.log("asd");

});


/* Filter Custom Functions */
function enableStickySidebar() {
  $('#gf-tree > *').wrapAll('<div class="gf-tree-inner"></div>');
  $('#gf-tree').stickySidebar({
    topSpacing: 100,
    bottomSpacing: 60,
    minWidth: 768
  });
  var url = new URL(window.location.href);
  var sortParam = url.searchParams.get("sort_by");

  $('<h4 class="hidden-xs">Sort by:</h4>').prependTo('.globo-dropdown-custom__options');

  if (sortParam) {
    $(".globo-dropdown-custom__options span").removeClass("sortby-selected");
    $('.globo-dropdown-custom__options [data-sort=' + sortParam + ']').addClass("sortby-selected");

  } else {
    $(".globo-dropdown-custom__options span").removeClass("sortby-selected");
    $(".globo-dropdown-custom__options span").eq(0).addClass("sortby-selected");
  }

  $("#globo-dropdown-sort_options").on("click", "span", function() {
    $(this).addClass("sortby-selected").siblings().removeClass("sortby-selected");
  });
  $('<h4 class="visible-xs mobile-sort-label"><i class="fa-solid fa-sort"></i> Sort by</h4>').prependTo('.sort-by');
  $('<span class="showing-no-label">Showing: </span>').prependTo('.gf-summary');
  $('.gf-summary').clone().addClass("visible-xs").insertBefore('#gf-products');

  $('#globo-dropdown-sort_options span').on('click', function() {
    $('html, body').animate({
      scrollTop: $('#Collection').offset().top - 100
    }, 'fast');
  });

}
var isFirstRendered = 0;
window.addEventListener("globoFilterRenderCompleted", function(event) {
  isFirstRendered = isFirstRendered + 1;
  $(".product-card--carousel").on("click", ".bze-option", function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var target = $(this).data("target");
    var mappedValue = $(this).data("mapped");
    var selectedFormID = $(this).closest(".buttonize").data("formid");
    $("#" + target)
      .val($(this).data("value"))
      .trigger("change");
    document.getElementById(target).dispatchEvent(new Event("change"));
    $("#" + selectedFormID)
      .find("#prop-packs")
      .val(mappedValue);
    $('.bze-option[data-target="' + target + '"]').removeClass("is-active");
    $(this).addClass("is-active");
    $(this).parent(".prod-card-custom-drop-value").parent(".custom-select").find(".prod-card-custom-selected-data").text($(this).text());
  });

  $(".prod-card-product-variation-drp").click(function() {
    $(".prod-card-custom-drop-value").hide();
    $(this).parent(".custom-select").find(".prod-card-custom-drop-value").show();
  });

  $(".prod-card-custom-drop-value").click(function() {
    $(this).hide();
  });

  $('[data-section-type="product"]:not(.prod-loaded)').each(function() {
    $(this).addClass("prod-loaded");
    new theme.Product(this);
    console.log('called');
  });



  if (isFirstRendered <= 1) {
    setTimeout(enableStickySidebar, 500);
  }

  setTimeout(function() {
    if (!$('.showing-no-label').length) {
      $('<span class="showing-no-label">Showing: </span>').prependTo('.gf-summary');
    }
  }, 500);

});

/* Highlight clicked collection on top of the filter */
$(function() {
  if ($('.template-collection').length) {
    var currURL = new URL(window.location.href);
    var collectionPath = currURL.pathname;
    $('a[href="' + collectionPath + '"]').parent().addClass("active");
  }
});


/* Search page dropdown variants FIx */
$(function() {

  /* Search bar enter / submit fix*/
  $('.search-bar__submit').on('click', function() {
    $('.search-bar__form').submit();
  });
  if ($(".template-search").length) {
    $(".list-view-items").on("click", ".bze-option", function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var target = $(this).data("target");
      var mappedValue = $(this).data("mapped");
      var selectedFormID = $(this).closest(".buttonize").data("formid");
      $("#" + target)
        .val($(this).data("value"))
        .trigger("change");
      document.getElementById(target).dispatchEvent(new Event("change"));
      $("#" + selectedFormID)
        .find("#prop-packs")
        .val(mappedValue);
      $('.bze-option[data-target="' + target + '"]').removeClass("is-active");
      $(this).addClass("is-active");
      $(this).parent(".prod-card-custom-drop-value").parent(".custom-select").find(".prod-card-custom-selected-data").text($(this).text());
    });

    $(".prod-card-product-variation-drp").click(function() {
      $(".prod-card-custom-drop-value").hide();
      $(this).parent(".custom-select").find(".prod-card-custom-drop-value").show();
    });

    $(".prod-card-custom-drop-value").click(function() {
      $(this).hide();
    });
  }
});
var isProductSwiper = document.getElementsByClassName('product-swiper');
if (isProductSwiper.length > 0) {
  var proswiper = new Swiper('.product-swiper', {
    // Default parameters
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: false,
    //{
    // delay: 5000,
    //  },
    // If we need pagination
    pagination: {
      el: '.pdp-swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

// NOTE: setup produtct main slider
var isProductSwiper = document.getElementsByClassName('newleanlite-product-swiper');
const shouldRenderThumbnails = document.body.hasAttribute('data-ab-thumbs');
const sliderThumnails = document.querySelector('.er-thumbnails');
let swiperThumbnails = null;


console.log('er thumbs', shouldRenderThumbnails, sliderThumnails)
if (shouldRenderThumbnails) {
  swiperThumbnails = new Swiper(sliderThumnails, {
    slidesPerView: 6,
    spaceBetween: 8,
    autoplay: false,
    watchSlidesProgress: true,
  });
}


if (isProductSwiper.length > 0) {
  var proswiper = new Swiper('.newleanlite-product-swiper:not(.er-thumbnails)', {
    // Default parameters
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: false,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: shouldRenderThumbnails ? 1 : 1.5,
        spaceBetween: 5
      },
      749: {
        slidesPerView: 1,
        spaceBetween: 40
      }
    },
    loop: !window.location.pathname.includes('skin-renew-orange'),
      ...(shouldRenderThumbnails ? { thumbs: { swiper: swiperThumbnails } } : {
        pagination: {
          el: '.pdp-swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      })
  });

  if (shouldRenderThumbnails) {
    const speed = 400;
    const slides = document.querySelectorAll('.er-thumbnails .swiper-wrapper > .swiper-slide');
    slides.forEach((slide, index) => {
      slide.addEventListener('click', () => {

        swiperThumbnails.slideTo(index, speed);
        proswiper.slideToLoop(index, speed);
      })
    })
  }

}

function resetPasswordSuccess() {
  var formState = document.querySelector('.reset-password-success');

  // check if reset password form was successfully submited.
  if (!formState) {
    return;
  }

  // show success message
  var resetSuccess = document.getElementById('ResetSuccess');
  resetSuccess.classList.remove('hide');
  resetSuccess.focus();
}

$(document).ready(function() {
  theme.customerTemplates.init();

  const swiper = new Swiper('.newleanliteswiper', {
    // Default parameters
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    arrow: false,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.6,
        spaceBetween: 25
      },
      749: {
        slidesPerView: 3,
        spaceBetween: 40
      }
    }
  });
});

$(document).ready(function() {
  theme.customerTemplates.init();

  const swiper = new Swiper('.newleanliteproswiper', {
    // Default parameters
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    loop: true,
    arrow: true,
    autoplay: true,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      749: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  });
});



// var winH = $(window).outerHeight();

// $(window).on("scroll", function (e) {
//   var scrollTopPos = $(window).scrollTop();
//   var bannerOffTop = bannerOffset ? bannerOffset.top : 0;
//   if (bannerOffTop + winH <= scrollTopPos) {
//     $('.article__card_slide').not('.slick-initialized').slick({
//       infinite: true,
//       slidesToShow: 3,
//       slidesToScroll: 1,
//       row:0,
//       dots: true,
//       arrows: true,
//       prevArrow: "<svg class='img-responsive slick-prev' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M7.5 14L1 7.5L7.5 1' stroke='black' stroke-linecap='round'/> </svg>",
//       nextArrow: "<svg class='img-responsive slick-arrow slick-next' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'> <path opacity='0.6' d='M0.5 14L7 7.5L0.5 1' stroke='black' stroke-linecap='round'/> </svg>",
//       responsive: [
//           {
//           breakpoint: 767,
//           settings: {
//             arrows: true,
//             slidesToShow:1,
//             centerMode: true,
//           }
//           },

//       ]
//     });
//   }
// });

var winH = $(window).outerHeight();

$(window).on("scroll", function(e) {
  var scrollTopPos = $(window).scrollTop();
  // Define bannerOffset here, safely checking if the element exists
  var bannerOffset = $("#Collection").length ? $("#Collection").offset() : null;
  // Use a ternary operator to safely check if bannerOffset is not null
  var bannerOffTop = bannerOffset ? bannerOffset.top : 0;

  // Check if the top position of the banner plus the window height is less than or equal to the scroll top position
  if (bannerOffTop + winH <= scrollTopPos) {
    // Initialize slick on elements that have not been initialized yet
    $('.article__card_slide').not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      prevArrow: "<svg class='img-responsive slick-prev' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path opacity='0.6' d='M7.5 14L1 7.5L7.5 1' stroke='black' stroke-linecap='round'/></svg>",
      nextArrow: "<svg class='img-responsive slick-arrow slick-next' width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path opacity='0.6' d='M0.5 14L7 7.5L0.5 1' stroke='black' stroke-linecap='round'/></svg>",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: true,
            slidesToShow: 1,
            centerMode: true,
          }
        },
      ]
    });
  }
});
